import { render, staticRenderFns } from "./RouteLive.vue?vue&type=template&id=197b2731&scoped=true"
import script from "./RouteLive.vue?vue&type=script&lang=js"
export * from "./RouteLive.vue?vue&type=script&lang=js"
import style0 from "./RouteLive.vue?vue&type=style&index=0&id=197b2731&prod&lang=less"
import style1 from "./RouteLive.vue?vue&type=style&index=1&id=197b2731&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197b2731",
  null
  
)

export default component.exports